import type { CustomTheme } from '../../../themes/types';

interface ButtonColorsSectionProps {
  readonly value: Pick<CustomTheme, 'buttonColorMode' | 'buttonColor'>;
  readonly onChange: (patch: Partial<Pick<CustomTheme, 'buttonColorMode' | 'buttonColor'>>) => void;
}

const MODES: Array<{ key: CustomTheme['buttonColorMode']; label: string }> = [
  { key: 'palette', label: 'Käytä palettia' },
  { key: 'single', label: 'Yksi väri' },
  { key: 'randomize', label: 'Arvo värit' },
];

export function ButtonColorsSection({ value, onChange }: ButtonColorsSectionProps) {
  return (
    <fieldset className="theme-editor__section">
      <legend>Napit</legend>
      <div className="theme-editor__tabs">
        {MODES.map((m) => (
          <button
            key={m.key}
            type="button"
            className={value.buttonColorMode === m.key ? 'active' : ''}
            onClick={() => onChange({ buttonColorMode: m.key })}
          >
            {m.label}
          </button>
        ))}
      </div>
      {value.buttonColorMode === 'single' ? (
        <label className="theme-editor__single-color">
          <span>Napin väri</span>
          <input
            type="color"
            value={value.buttonColor ?? '#52c5f0'}
            onChange={(e) => onChange({ buttonColor: e.target.value })}
          />
        </label>
      ) : null}
    </fieldset>
  );
}
